import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from "@angular/core";
import { Asset } from "src/app/models/asset";
import { Comment } from "src/app/models/comment";
import { HttpService } from "src/app/modules/assetModule/shared/services/http.service";
import { Quality } from "src/app/models/quality";
import { UserService } from "src/app/modules/userModule/shared/user.service";
import { FormControl, Validators } from "@angular/forms";
import { AssetFileSpecification } from "src/app/models/assetFileSpecification";

import { AssetComments } from "src/app/models/assetComments";
import { User } from "src/app/models/user";
import { Rating } from "src/app/models/rating";
import { AssetFile } from "src/app/models/assetFile";
import { Router, ActivatedRoute } from "@angular/router";

import { Location } from '@angular/common';
import { RatingComponent } from "src/app/shared/components/rating/rating.component";

@Component({
  selector: "app-asset-specification",
  templateUrl: "./asset-specification.component.html",
  styleUrls: ["./asset-specification.component.css"]
})
export class AssetSpecificationComponent implements OnInit {

  @ViewChild(RatingComponent) starRate:RatingComponent;

  user: User = new User();
  @Input() asset: Asset;
  @Input() assetPath;
  @Input() formats;
  @Input() quality;
  @Input() textureQuality;
  @Input() assetFilePath;
  @Input() loadAsset;

  @Output()
  uneditedAssetEmit: EventEmitter<Asset> = new EventEmitter<Asset>();
  @Output()
  selectedAssetFile: EventEmitter<AssetFile> = new EventEmitter<AssetFile>();
  @Output()
  deleteEmit: EventEmitter<any> = new EventEmitter<any>();

  experiencedMode;
  params = '';
  textQuality = new Quality();
  comments: Array<Comment> = new Array<Comment>();

  assetFileSpecifaction: AssetFileSpecification = new AssetFileSpecification();
  uneditedAsset: Asset = new Asset();

  primaryContactNameControl = new FormControl("", [Validators.required]);
  primaryContactEmailControl = new FormControl("", [
    Validators.email,
    Validators.required,
    Validators.pattern(".*@siemens-healthineers.com")
  ]);

  constructor(
    private httpServices: HttpService,
    public userService: UserService,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute
  ) { }
  
  showAddCommentDiv = false;
  newComment: AssetComments;
  commentSubjectError = false;
  commentDescriptionError = false;
  showEdit = false;
  updateText = "Modify";
  edit = false;

  selectedAsset: AssetFile;
  unEditedAssetFile: AssetFile;
  versionList = [];
  assetsInAVertion: Array<AssetFile> = new Array<AssetFile>();
  assetsInFormats: Array<AssetFile> = new Array<AssetFile>();
  selectedVersion: string;
  loader = false;
  renameEnable = false;
  editedAssetName = "";
  assetNameExists = false;
  assetNameError = false;
  validVersions: number;
  rate: number = 1;
  info: string = "not rated";

  ngOnInit() {
    this.httpServices.currentSearchPath.subscribe(path=> {
      this.params = path;
    })
    if (!this.params) {
      this.activatedRoute.params.subscribe(param=> {
        this.params = param.folder;
      });
    }
    console.log(this.formats, this.quality);
    this.versionList = [];
    this.editedAssetName = this.asset.name;

    if (this.asset) {
      if (this.userService.loggendInUser.assetsSubscribedTo.indexOf(this.asset._id) > -1) {
        this.asset.inform = true;
      }

      this.asset.assetfiles.forEach(a => {
        if (a.versionNo && this.versionList.indexOf(a.versionNo) <= -1)
          this.versionList.push({ version: a.versionNo, deleted: a.deleted });
      });
      let i = this.versionList.length - 1;
      while (i >= 0) {
        if (!this.selectedVersion)
          this.selectedVersion = this.versionList[i].deleted ? this.selectedVersion : this.versionList[i].version;
        else
          break;
        i--;
      }
      this.httpServices.selectedVersionNumber = this.selectedVersion;
      this.assetsInAVertion = this.asset.assetfiles.filter(
        asset => asset.versionNo === this.selectedVersion
      );
      this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInAVertion[0]));

      this.formatsForSelectedAssets(this.assetsInAVertion);
      this.qualityForSelectedFormat(this.selectedAsset.specification.fileFormat);

      // this.formats = [this.selectedAsset.specification.fileFormat];
      // this.quality = [this.selectedAsset.specification.fileQuality];
      // this.textureQuality = [this.selectedAsset.specification.textureQuality];

      this.primaryContactNameControl = new FormControl(this.asset.attributes.primaryContact.name, [
        Validators.required
      ]);
      this.primaryContactEmailControl = new FormControl(
        this.asset.attributes.primaryContact.emailId,
        [Validators.email, Validators.required, Validators.pattern(".*@siemens-healthineers.com")]
      );
      this.assetFileSpecifaction = this.selectedAsset.specification;
      this.asset.comments = this.asset.comments
        ? this.asset.comments.reverse()
        : new Array<AssetComments>();
    }

    this.experiencedMode = this.userService.loggendInUser.userSettings.userProfileType;

    this.showEdit =
      this.userService.loggendInUser.userEmailId.split("@")[0] === this.asset.attributes.uploader ||
      this.userService.loggendInUser.userEmailId === this.asset.attributes.primaryContact.emailId;
    this.httpServices.assetDetails = { assetName: this.asset.name, assetId: this.asset._id };
    this.httpServices.selectedVersionNumber = this.selectedAsset.versionNo;

    ///---------------------------------------///
    if (null != this.asset.avgRating) {
      this.info = this.asset.avgRating;
    }
    this.httpServices.count = this.asset.noOfRatings;
    this.httpServices.avgRt = this.asset.avgRating;
    ///---------------------------------------///
    this.httpServices.assetDetails.avgRt = this.asset.avgRating;

  }

  modifyAsset() {
    this.uneditedAsset = JSON.parse(JSON.stringify(this.asset));
    this.unEditedAssetFile = JSON.parse(JSON.stringify(this.selectedAsset));
    this.primaryContactNameControl.setValue(this.asset.attributes.primaryContact.name);
    this.primaryContactEmailControl.setValue(this.asset.attributes.primaryContact.emailId);
  }

  cancelEdit() {
    this.asset = this.uneditedAsset;
    this.selectedAsset = this.unEditedAssetFile;
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.uneditedAssetEmit.emit(this.asset);
    this.edit = false;
  }

  changeCheckBoxValue(obj, param) {
    // if (!sessionStorage.getItem("checked") || sessionStorage.getItem("checked") !== "1") {
    //   //data = !data;
    //   obj[param] = !obj[param];
    //   sessionStorage.setItem("checked", "1");
    // } else sessionStorage.setItem("checked", "0");
    setTimeout(() => {
      obj[param] = !obj[param];
    });
  }

  inform(asset) {
    asset.inform = !asset.inform;
    this.subscribeAsset(asset.inform);
  }

  download() {
    // debugger
    window.open(
      `${this.httpServices.basePath}/asset/download/${this.asset._id}/${
      this.selectedAsset.versionNo
      }/${this.selectedAsset.specification.fileFormat}/${
      this.selectedAsset.specification.fileQuality
      }/${this.selectedAsset.specification.textureQuality}/${this.userService.loggendInUser.userEmailId}`
    );
    this.httpServices.addAssetDownload(this.userService.loggendInUser.userEmailId, this.asset._id).subscribe(
      data => {
        console.log(data);
      }, err => {
        console.log(err);
      }
    );

    // this.httpServices.download(`${this.httpServices.basePath}/asset/download/${this.asset._id}`).subscribe(
    //   data => {
    //     let fileElement = document.createElement("a"),
    //       url = URL.createObjectURL(new Blob([data], { type: "application/zip" }));
    //     fileElement.href = url;
    //     fileElement.download = this.asset.name;
    //     document.body.appendChild(fileElement);
    //     fileElement.click();

    //     setTimeout(function () {
    //       document.body.removeChild(fileElement);
    //       window.URL.revokeObjectURL(url);
    //     }, 0);
    //   }, err => {
    //     console.error(err)
    //   }
    // )
  }

  validateEmailId(email: string): boolean {
    let emailValid = true;
    if (!email.endsWith("@siemens-healthineers.com")) {
      emailValid = false;
    }
    return !emailValid;
  }

  updateAsset() {
    this.asset.assetfiles.splice(
      this.asset.assetfiles.indexOf(
        this.asset.assetfiles.find(a => a._id === this.selectedAsset._id)
      ),
      1
    );
    this.asset.assetfiles.push(this.selectedAsset);
    if (this.primaryContactNameControl.valid && this.primaryContactEmailControl.valid) {
      this.httpServices.updateAsset(this.asset, this.userService.loggendInUser.userEmailId, this.asset._id).subscribe(
        data => {
          this.asset = data;
          const assetIdIndex = this.userService.loggendInUser.assetsSubscribedTo.indexOf(
            this.asset._id
          );
          if (assetIdIndex <= -1) {
            this.asset.inform = false;
          } else {
            this.asset.inform = true;
          }

          this.assetFileSpecifaction = this.selectedAsset.specification;
          this.uneditedAssetEmit.emit(this.asset);
          this.showEdit =
            this.userService.loggendInUser.userEmailId.split("@")[0] ===
            this.asset.attributes.uploader ||
            this.userService.loggendInUser.userEmailId ===
            this.asset.attributes.primaryContact.emailId;
          document.getElementById("my-modal").removeAttribute("visible");
        },
        err => {
          console.error(err);
        },
        () => {
          this.edit = false;
        }
      );
    }
  }

  showAddComment() {
    this.newComment = new AssetComments();
    this.newComment.subject = "";
    this.newComment.description = "";
    this.showAddCommentDiv = true;
    this.commentSubjectError = false;
    this.commentDescriptionError = false;
  }

  validateComment(): boolean {
    let isValid = true;
    if (!this.newComment.subject || "" === this.newComment.subject.trim()) {
      isValid = false;
      this.commentSubjectError = true;
    } else {
      this.commentSubjectError = false;
    }
    if (!this.newComment.description || "" === this.newComment.description.trim()) {
      isValid = false;
      this.commentDescriptionError = true;
    } else {
      this.commentDescriptionError = false;
    }
    return isValid;
  }

  addComment() {
    if (this.validateComment()) {
      let loggedInUser = JSON.parse(sessionStorage.getItem("userinfo")) as User;
      this.newComment.createdByUser = loggedInUser.userEmailId;
      this.newComment.userName = loggedInUser.name;
      this.newComment.createdOn = new Date();
      this.newComment.forAssetVersion = Number(this.selectedVersion);

      this.httpServices.addComment(this.asset._id, this.asset.name, this.newComment).subscribe(
        (data: Array<AssetComments>) => {
          if (null !== data) {
            this.asset.comments = data.reverse();
          }
          this.showAddCommentDiv = false;
        },
        error => { }
      );
    }
  }

  subscribeAsset(isSubscribe: boolean) {
    this.httpServices
      .subscribeAsset(this.asset._id, this.asset.name, this.userService.loggendInUser.userEmailId, isSubscribe)
      .subscribe(
        data => {
          // document.getElementById('success').click();
          let assetIdIndex = this.userService.loggendInUser.assetsSubscribedTo.indexOf(
            this.asset._id
          );
          if (assetIdIndex <= -1) {
            this.userService.loggendInUser.assetsSubscribedTo.push(this.asset._id);
          } else {
            this.userService.loggendInUser.assetsSubscribedTo.splice(assetIdIndex, 1);
          }
          sessionStorage.setItem("userinfo", JSON.stringify(this.userService.loggendInUser));
          console.log("Subscribed");
        },
        err => {
          console.log(err);
        }
      );
  }

  newVersion() {
    this.httpServices.newVersionFlag = true;
    this.httpServices.asset = this.asset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  newExtension() {
 
    this.httpServices.newExtensionFlag = true;
    this.httpServices.asset = this.asset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  changeVersion(version: string) {
    this.assetsInAVertion = this.asset.assetfiles.filter(asset => asset.versionNo === version);
    this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInAVertion[0]));

    this.formatsForSelectedAssets(this.assetsInAVertion);
    this.qualityForSelectedFormat(this.selectedAsset.specification.fileFormat);
    // this.selectedAsset = this.asset.assetfiles.filter(a => a.versionNo === version)[0];
    let supportedFiles: Array<String> = ["obj", "fbx", "stl"];

    let file = this.assetsInAVertion.find(
      a => supportedFiles.indexOf(a.specification.fileFormat.toLowerCase()) > -1
    );
    if (file) {
      this.selectedAssetFile.emit(file);
    } else {
      this.selectedAssetFile.emit(this.selectedAsset);
    }

    // this.formats = [this.selectedAsset.specification.fileFormat];
    // this.quality = [this.selectedAsset.specification.fileQuality];
    // this.textureQuality = [this.selectedAsset.specification.textureQuality];
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.httpServices.selectedVersionNumber = version;
  }

  formatsForSelectedAssets(selectedAssets: Array<AssetFile>) {
    this.formats = [];
    selectedAssets.forEach(f => {
      if (this.formats.indexOf(f.specification.fileFormat) <= -1)
        this.formats.push(f.specification.fileFormat);
    });
  }

  qualityForSelectedFormat(format: String) {
    this.textureQuality = [];
    this.quality = [];
    this.assetsInFormats = this.assetsInAVertion.filter(
      asset => asset.specification.fileFormat === format
    );
    this.selectedAsset = JSON.parse(JSON.stringify(this.assetsInFormats[0]));
    this.assetFileSpecifaction = this.selectedAsset.specification;
    this.assetsInFormats.forEach(f => {
      this.quality.push(f.specification.fileQuality);
      this.textureQuality.push(f.specification.textureQuality);
    });
  }

  selectAssetOnFileQuality(fileQuality: Number, textureQuality: Number) {
    if (
      !this.assetsInFormats.filter(
        asset =>
          asset.specification.fileQuality === fileQuality &&
          asset.specification.textureQuality === textureQuality
      )[0]
    ) {
      this.selectedAsset = JSON.parse(
        JSON.stringify(
          this.assetsInFormats.find(asset => asset.specification.fileQuality === fileQuality)
        )
      );
      this.assetFileSpecifaction = this.selectedAsset.specification;
    } else this.selectAssetOnQuality(fileQuality, textureQuality);
  }

  selectAssetOnTextureQuality(fileQuality: Number, textureQuality: Number) {
    if (
      !this.assetsInFormats.filter(
        asset =>
          asset.specification.fileQuality === fileQuality &&
          asset.specification.textureQuality === textureQuality
      )[0]
    ) {
      this.selectedAsset = JSON.parse(
        JSON.stringify(
          this.assetsInFormats.find(asset => asset.specification.textureQuality === textureQuality)
        )
      );
      this.assetFileSpecifaction = this.selectedAsset.specification;
    } else this.selectAssetOnQuality(fileQuality, textureQuality);
  }

  selectAssetOnQuality(fileQuality: Number, textureQuality: Number) {
    this.selectedAsset = JSON.parse(
      JSON.stringify(
        this.assetsInFormats.filter(
          asset =>
            asset.specification.fileQuality === fileQuality &&
            asset.specification.textureQuality === textureQuality
        )[0]
      )
    );
    this.assetFileSpecifaction = this.selectedAsset.specification;
  }

  updateAssetFile() {

    this.httpServices.updateAssetFile = true;
    this.httpServices.asset = this.asset;
    this.httpServices.selectedAssetFile = this.selectedAsset;
    this.router.navigateByUrl(`/val-assets/upload-assets/${this.params}`);
  }

  deleteAsset() {
    document.getElementById('delete-confirmation').removeAttribute('visible');
    this.loader = true;
    this.httpServices.deleteAsset(this.asset._id, this.httpServices.folder._id, this.userService.loggendInUser.userEmailId).subscribe(
      () => {
        // this.router.navigateByUrl("/val-assets/search");
      }, err => {
        console.error(err);
        this.loader = false;
      }, () => {
        console.log('deleted');
        this.loader = false;
        let url = this.router.url
        if (url.indexOf('search') > 0) {
          this.location.go(`/val-assets/search`);
        } else if (url.indexOf('personal-browser') > 0) {
          this.location.go(`/val-assets/personal-browser`);
        }
        this.asset.relativePath = null;
        this.deleteEmit.emit(this.httpServices.folder);
        // this.router.navigateByUrl("/val-assets/search");
      }
    );
  }

  renameAsset() {
    this.assetNameError = false;
    this.assetNameExists = false;
    if (this.editedAssetName.length == 0) {
      this.assetNameError = true;
    }
    else if (this.httpServices.folder.assetList.filter(asset => asset.name.toLowerCase() === this.editedAssetName.toLowerCase()).length > 0) {
      this.assetNameExists = true;
    } else {
      this.loader = true;
      //put call for renaming asset
      this.httpServices.renameAsset(this.editedAssetName.trim(), this.asset._id, this.httpServices.folder._id, this.userService.loggendInUser.userEmailId).subscribe(
        (data: Asset) => {
          let assetTree = this.httpServices.folder.assetList.find((asset: Asset) => asset.name.toLowerCase() === this.asset.name.toLowerCase());
          assetTree.name = this.editedAssetName;
          this.asset = data;
          this.assetPath = this.asset.relativePath;
        }, err => {
          console.log(err);
          this.loader = false;
        }, () => {
          this.loader = false;
          this.renameEnable = false;
        }
      )
    }
  }

  deleteConfirmationPopUp() {
    this.validVersions = this.versionList.filter(x => x.deleted != true).length;
    document.getElementById('delete-confirmation').setAttribute('visible', 'true');
  }

  deleteAssetVersion() {
    document.getElementById('delete-confirmation').removeAttribute('visible');
    this.loader = true;
    this.httpServices.deleteAssetVersion(this.asset._id, this.selectedVersion, this.userService.loggendInUser.userEmailId).subscribe(
      (data: any) => {
        this.loader = false;
        this.versionList.find(x => x.version == this.selectedVersion).deleted = true;
        let i = this.versionList.length - 1;
        this.selectedVersion = null;
        while (i >= 0) {
          if (!this.selectedVersion)
            this.selectedVersion = this.versionList[i].deleted ? this.selectedVersion : this.versionList[i].version;
          else {
            this.changeVersion(this.selectedVersion);
            break;
          }
          i--;
        }
        this.httpServices.assetDetails.avgRt = data[1];
        this.httpServices.asset.avgRating = data[1];
        this.httpServices.count = data[0];
        this.httpServices.avgRt = data[1];
        this.starRate.rating = data[1];
      },
      () => {
        this.loader = false;
      }
    );
  }

  ngOnDestroy() {
    this.httpServices.assetDetails = null;
  }
}
